/**
 * @returns Money or an empty object if price is undefined.
 */

export const getPlanPrice = plan => plan?.pricing?.price ?? {};
//# sourceMappingURL=get-plan-price.js.map